import { SkeletonLoader } from '@design';
import React from 'react';

import styles from './InsightsLoadingCard.module.scss';

export const InsightsLoadingCard = () => {
  return (
    <div className={styles.loadingWrapper}>
      <SkeletonLoader
        data-testid="insights-group-loading"
        areas={[
          {
            styles: {
              width: '100%',
              height: 60,
            },
          },
        ]}
      />
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: 60,
            },
          },
        ]}
      />
    </div>
  );
};
